import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

import { IGlobalPartnerForm } from '../../../../../models/globalPartnerForm'

export const applyGPBasicInfoChanges = async (data: IGlobalPartnerForm, fYear: number) => {
  const url = proxy(`/webservice/197/sp/v4/spJBPGlobalPartnersApply/call`)
  const payload = {
    'p.Action': data.globalPartnerId ? 'Update' : 'Create',
    'p.GlobalPartnerId': data.globalPartnerId,
    'p.GlobalPartnerName': data.globalPartnerName,
    'p.PBM': data.pbm.join(','),
    'p.Managers': data.managers.join(','),
    'p.RTM': data.rtm,
    'p.FYear': fYear,
    'p.IsITS': data.isIts,
    'p.IsReflectOnDashboards': data.isReflectOnDashboards,
    'p.ExecutiveSummary': data.executiveSummary,
    'p.Offerings': JSON.stringify(
      data.offeringsState.map((el) => ({
        ProgramType: el.programType,
        Enabled: Number(el.enabled),
      }))
    ),
  }
  const {
    app: { ownerId },
  } = appGetState()
  const [accessToken] = getTokens(ownerId)

  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }
  const response = await Rest.post({ url, payload, headers })

  if (response?.Data?.length > 0) {
    return response.Data[0].GlobalPartnerId
  }
  return null
}
